export default __webpack_public_path__ + "static/media/promos-icon-active.37698197.webp";